<template>
  <div>
    <h1 class="header-style">
      Contractor <br> Check-out
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-out.
    </p>
    <v-stepper
      v-model="userCheckOut"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckOut > 1"
          step="1"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckOut > 2"
          step="2"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckOut > 3"
          color="#000"
          step="3"
        />
      </v-stepper-header>
    </v-stepper>
    <div>
      <contractor-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <gather-contract-progress
        v-if="showContractProgress"
        @contract-progress-stored="toThirdStep"
      />
      <review-contract-checkout
        v-if="showContractorCheckoutPage"
        @checkout-completed="checkOutCompleted"
      />
    </div>
  </div>
</template>
  <script>
  import ContractorLocationVerification from '../dialogComponents/ContractorDialogs/checkout/ContractorLocationVerification.vue';
  import GatherContractProgress from '../dialogComponents/ContractorDialogs/checkout/GatherContractProgress.vue';
  import ReviewContractCheckOut from '../dialogComponents/ContractorDialogs/checkout/ReviewContractorCheckout.vue';

  export default {
    name: 'ContractorCheckoutPage',
    components: {
      'contractor-location-verification': ContractorLocationVerification,
      'gather-contract-progress': GatherContractProgress,
      'review-contract-checkout': ReviewContractCheckOut,
    },
    data () {
      return {
        userCheckOut: 1,
        showLocationVerificationPage: true,
        step1SuccessColor: '',
        showContractProgress: false,
        step2SuccessColor: '',
        showContractorCheckoutPage: false,
      };
    },
    computed: {
      step1Success () {
        return `color:${this.step1SuccessColor}`;
      },
      step2Success () {
        return `color:${this.step2SuccessColor}`;
      },
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      isActiveCheckInDetailsFetched () {
        if (Object.keys(this.activeCheckInDetails).length > 0) {
          return true;
        }
        return false;
      },
      checkOutMethodType () {
        return this.$store.getters['swiftuser/getCheckOutMethodType'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    async mounted () {
      await this.fetchActiveCheckInDetails();
      this.loadOnMount();
      this.fetchOrgDetails();
    },
    methods: {
      loadOnMount () {
        if (this.checkOutMethodType === null) {
          this.$router.push({ name: 'CheckOut' });
        }
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.activeCheckInDetails);
      },
      async fetchActiveCheckInDetails () {
        this.loading = true;
        await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails').then(response => {
          if (this.isActiveCheckInDetailsFetched === true) {
            this.loading = false;
            return;
          }
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        }).catch(() => {
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        });
      },
      toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.userCheckOut = 2;
        this.showLocationVerificationPage = false;
        this.showContractorCheckoutPage = false;
        this.showContractProgress = true;
      },
      toThirdStep () {
        this.step2SuccessColor = '#00796B';
        this.userCheckOut = 3;
        this.showLocationVerificationPage = false;
        this.showContractProgress = false;
        this.showContractorCheckoutPage = true;
      },
      checkOutCompleted () {
        this.$router.push({ name: 'HomePage' });
      },
    },
  };
</script>
